module.exports = __webpack_public_path__ + "img/logo.3b8987d6.png";